import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-77e0b18b"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "bg-yellow-bar text-gray-800 p-2 font-semibold m-2 text-sm" }
const _hoisted_2 = {
  key: 1,
  class: "cover-img p-0 m-2 block overflow-hidden"
}
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "bg-black-body m-2" }
const _hoisted_5 = { class: "md:grid md:grid-cols-3 game-details text-white p-5 pt-7 border-bottom-theme" }
const _hoisted_6 = { class: "col-span-2" }
const _hoisted_7 = { class: "text-white text-4xl mb-4 font-semibold" }
const _hoisted_8 = { class: "m-0 text-sm flex items-center" }
const _hoisted_9 = /*#__PURE__*/_createTextVNode("By: ")
const _hoisted_10 = { class: "text-gray-text flex items-center" }
const _hoisted_11 = /*#__PURE__*/_createTextVNode("Browser ")
const _hoisted_12 = { class: "text-gray-text flex items-center" }
const _hoisted_13 = {
  key: 0,
  class: "text-gray-text flex items-center"
}
const _hoisted_14 = /*#__PURE__*/_createTextVNode("Share with Friends ")
const _hoisted_15 = {
  key: 1,
  class: "text-gray-text"
}
const _hoisted_16 = {
  key: 2,
  class: "text-gray-text"
}
const _hoisted_17 = { class: "flex items-center" }
const _hoisted_18 = /*#__PURE__*/_createTextVNode("Play")
const _hoisted_19 = ["href"]
const _hoisted_20 = { class: "game-details text-white p-3 md:grid md:grid-cols-3 px-5" }
const _hoisted_21 = { class: "md:col-span-2 md:pr-3" }
const _hoisted_22 = { class: "description" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", null, "About this Game", -1))
const _hoisted_24 = ["innerHTML"]
const _hoisted_25 = {
  key: 1,
  class: "text-gray-text",
  style: {"margin-bottom":"10px"}
}
const _hoisted_26 = {
  key: 2,
  class: "pt-2"
}
const _hoisted_27 = {
  key: 3,
  class: "p-0 text-gray-text"
}
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", null, "Scary Bears and Cute Visuals", -1))
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", null, "Endless Gameplay", -1))
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", null, "Easy Controls", -1))
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", null, [
  /*#__PURE__*/_createElementVNode("a", {
    class: "text yellow-bar",
    "data-bs-toggle": "modal",
    "data-bs-target": "#popupLeavingXarcade",
    id: "btnpopupLeavingXarcade"
  }, "https://mygamerwebsite.com")
], -1))
const _hoisted_32 = [
  _hoisted_28,
  _hoisted_29,
  _hoisted_30,
  _hoisted_31
]
const _hoisted_33 = { class: "col-md-4 right-column" }
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { class: "pb-3 border-bottom-theme text-2xl font-semibold" }, "Game Details", -1))
const _hoisted_35 = { class: "md:grid md:grid-cols-2 py-3 border-bottom-theme text-sm" }
const _hoisted_36 = { class: "py-2" }
const _hoisted_37 = /*#__PURE__*/_createTextVNode("Game ID: ")
const _hoisted_38 = { class: "text-gray-text" }
const _hoisted_39 = {
  key: 0,
  class: "py-2"
}
const _hoisted_40 = /*#__PURE__*/_createTextVNode(" Last Update: ")
const _hoisted_41 = { class: "text-gray-text" }
const _hoisted_42 = { class: "py-2" }
const _hoisted_43 = /*#__PURE__*/_createTextVNode(" Content Rating: ")
const _hoisted_44 = { class: "text-gray-text" }
const _hoisted_45 = {
  key: 1,
  class: "py-2"
}
const _hoisted_46 = /*#__PURE__*/_createTextVNode(" Submission Date: ")
const _hoisted_47 = { class: "text-gray-text" }
const _hoisted_48 = {
  key: 2,
  class: "py-2"
}
const _hoisted_49 = /*#__PURE__*/_createTextVNode(" Played by: ")
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-gray-text" }, "12,225 users", -1))
const _hoisted_51 = [
  _hoisted_49,
  _hoisted_50
]
const _hoisted_52 = { class: "py-2" }
const _hoisted_53 = /*#__PURE__*/_createTextVNode(" Current Version: ")
const _hoisted_54 = { class: "text-gray-text" }
const _hoisted_55 = { class: "row gd-margin border-bottom-theme" }
const _hoisted_56 = { class: "col-md-6 py-2" }
const _hoisted_57 = /*#__PURE__*/_createTextVNode(" Developer: ")
const _hoisted_58 = { class: "text-red-primary" }
const _hoisted_59 = {
  key: 0,
  class: "row gd-margin border-bottom-theme"
}
const _hoisted_60 = { class: "col-md-12 py-2" }
const _hoisted_61 = /*#__PURE__*/_createTextVNode(" Platform: ")
const _hoisted_62 = { class: "text-gray-text" }
const _hoisted_63 = /*#__PURE__*/_createTextVNode("Browser ")
const _hoisted_64 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-md-12 py-2" }, [
  /*#__PURE__*/_createTextVNode(" Compatible Browser: "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-red-primary" }, "Chrome, Firefox, Safari, Opera, Edge")
], -1))
const _hoisted_65 = {
  key: 1,
  class: "row gd-margin border-bottom-theme"
}
const _hoisted_66 = { class: "col-md-12 py-2" }
const _hoisted_67 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Language:", -1))
const _hoisted_68 = { class: "text-red-primary" }
const _hoisted_69 = {
  key: 2,
  class: "row gd-margin border-bottom-theme"
}
const _hoisted_70 = { class: "py-2" }
const _hoisted_71 = { key: 0 }
const _hoisted_72 = { key: 1 }
const _hoisted_73 = { class: "row gd-margin" }
const _hoisted_74 = { class: "py-2" }
const _hoisted_75 = /*#__PURE__*/_createTextVNode(" Feedback: ")
const _hoisted_76 = {
  key: 0,
  class: "modal fade",
  id: "popupLeavingXarcade",
  tabindex: "-1",
  "aria-labelledby": "staticBackdropLabel",
  "aria-hidden": "true"
}
const _hoisted_77 = { class: "modal-dialog modal-dialog-centered" }
const _hoisted_78 = { class: "modal-content bg-xr-card text-white" }
const _hoisted_79 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "overlay" }, null, -1))
const _hoisted_80 = { class: "modal-body text-center" }
const _hoisted_81 = ["src"]
const _hoisted_82 = /*#__PURE__*/_createStaticVNode("<h2 class=\"text-red-primary m-0 mb-3\" data-v-77e0b18b>You are leaving MetX Games</h2><p class=\"text-white mb-3\" data-v-77e0b18b> The below link is not a MetX Games website: </p><p class=\"text-warning mb-4\" data-v-77e0b18b><a class=\"text-warning\" data-v-77e0b18b>https://mygamerwebsite.com</a></p><p class=\"text-white mb-3\" data-v-77e0b18b> Please be advised to not use your MetX Games password on an unknown/untrusted website. </p><p class=\"text-white mb-3\" data-v-77e0b18b> Any login from an official MetaXar website will display MetaXar at the start with a green padlock like below: </p>", 5)
const _hoisted_87 = {
  class: "d-flex",
  style: {"justify-content":"center"}
}
const _hoisted_88 = { class: "btn bg-xr-body text-white d-block text-center" }
const _hoisted_89 = /*#__PURE__*/_createTextVNode(" metaxar.io")
const _hoisted_90 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", { class: "btn-primary mt-5 me-3" }, " Continue to External Website ", -1))
const _hoisted_91 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  type: "button",
  class: "btn bg-xr-body mt-5 text-gray-text",
  "data-bs-dismiss": "modal"
}, " Cancel ", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_GamesGalleryComponent = _resolveComponent("GamesGalleryComponent")!
  const _component_GamesFeedbackModal = _resolveComponent("GamesFeedbackModal")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("main", null, [
      _createElementVNode("div", _hoisted_1, "You are viewing this game in " + _toDisplayString(_ctx.label) + " Environment", 1),
      (_ctx.headerImage != 'none')
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "cover-img bg-gray-500 p-0 m-2 bg-blend-overlay",
            style: _normalizeStyle('background-image: url(' + _ctx.headerImage + '); background-repeat: no-repeat;')
          }, null, 4))
        : (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createElementVNode("img", {
              src: require(`@/assets/images/default-cover.png`)
            }, null, 8, _hoisted_3)
          ])),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.title), 1),
            _createElementVNode("ul", _hoisted_8, [
              _createElementVNode("li", null, [
                _hoisted_9,
                (_ctx.submittedById)
                  ? (_openBlock(), _createBlock(_component_router_link, {
                      key: 0,
                      to: {name: 'viewDeveloperProfile', params: {developerId: _ctx.submittedById}},
                      class: "text-red-primary hover:underline"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.submittedById), 1)
                      ]),
                      _: 1
                    }, 8, ["to"]))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("li", _hoisted_10, [
                _hoisted_11,
                _createVNode(_component_font_awesome_icon, {
                  icon: "fa-solid fa-earth-asia",
                  class: "inline-block ml-1 text-sm relative"
                })
              ]),
              _createElementVNode("li", _hoisted_12, [
                _createTextVNode(_toDisplayString(_ctx.gameCategory) + " ", 1),
                _createVNode(_component_font_awesome_icon, {
                  icon: "fa-solid fa-tree",
                  class: "inline-block ml-1 text-sm relative"
                })
              ]),
              false
                ? (_openBlock(), _createElementBlock("li", _hoisted_13, [
                    _hoisted_14,
                    _createVNode(_component_font_awesome_icon, {
                      icon: "fa-solid fa-share",
                      class: "inline-block ml-1 text-sm relative"
                    })
                  ]))
                : _createCommentVNode("", true),
              false
                ? (_openBlock(), _createElementBlock("li", _hoisted_15, [
                    _createVNode(_component_font_awesome_icon, {
                      icon: "fa-solid fa-heart",
                      class: "inline-block"
                    })
                  ]))
                : _createCommentVNode("", true),
              false
                ? (_openBlock(), _createElementBlock("li", _hoisted_16, [
                    _createVNode(_component_font_awesome_icon, {
                      icon: "fa-solid fa-tag",
                      class: "inline-block"
                    })
                  ]))
                : _createCommentVNode("", true)
            ])
          ]),
          _createElementVNode("div", _hoisted_17, [
            (_ctx.webglRelease.length > 0)
              ? (_openBlock(), _createBlock(_component_router_link, {
                  key: 0,
                  to: {name: 'viewGamesPlay', params: {gameId: _ctx.gameId}},
                  class: "btn-primary play-button mr-2"
                }, {
                  default: _withCtx(() => [
                    _hoisted_18
                  ]),
                  _: 1
                }, 8, ["to"]))
              : _createCommentVNode("", true),
            (_ctx.androidRelease.length > 0)
              ? (_openBlock(), _createElementBlock("a", {
                  key: 1,
                  href: _ctx.apk,
                  target: "_new",
                  class: "btn-primary play-button"
                }, [
                  _createVNode(_component_font_awesome_icon, {
                    icon: "fa-brands fa-android",
                    class: "inline-block mr-2"
                  }),
                  _createTextVNode("Android APK (" + _toDisplayString(_ctx.androidRelease[0].version) + ")", 1)
                ], 8, _hoisted_19))
              : _createCommentVNode("", true)
          ])
        ]),
        _createElementVNode("div", _hoisted_20, [
          _createElementVNode("div", _hoisted_21, [
            _createVNode(_component_GamesGalleryComponent, { gameId: _ctx.gameId }, null, 8, ["gameId"]),
            _createElementVNode("div", _hoisted_22, [
              _hoisted_23,
              (_ctx.about)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: "text-gray-text",
                    style: {"margin-bottom":"10px"},
                    innerHTML: _ctx.about
                  }, null, 8, _hoisted_24))
                : (_openBlock(), _createElementBlock("div", _hoisted_25, "-")),
              false
                ? (_openBlock(), _createElementBlock("h5", _hoisted_26, "Game Features"))
                : _createCommentVNode("", true),
              false
                ? (_openBlock(), _createElementBlock("ul", _hoisted_27, _hoisted_32))
                : _createCommentVNode("", true)
            ])
          ]),
          _createElementVNode("div", _hoisted_33, [
            _hoisted_34,
            _createElementVNode("div", _hoisted_35, [
              _createElementVNode("div", _hoisted_36, [
                _hoisted_37,
                _createElementVNode("span", _hoisted_38, _toDisplayString(_ctx.gameId), 1)
              ]),
              (_ctx.lastUpdate != _ctx.submissionDate && _ctx.lastUpdate != null)
                ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
                    _hoisted_40,
                    _createElementVNode("span", _hoisted_41, _toDisplayString(_ctx.lastUpdate), 1)
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_42, [
                _hoisted_43,
                _createElementVNode("span", _hoisted_44, _toDisplayString(_ctx.contentRating?_ctx.contentRating:'-'), 1)
              ]),
              (_ctx.submissionDate)
                ? (_openBlock(), _createElementBlock("div", _hoisted_45, [
                    _hoisted_46,
                    _createElementVNode("span", _hoisted_47, _toDisplayString(_ctx.submissionDate), 1)
                  ]))
                : _createCommentVNode("", true),
              false
                ? (_openBlock(), _createElementBlock("div", _hoisted_48, _hoisted_51))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_52, [
                _hoisted_53,
                _createElementVNode("span", _hoisted_54, _toDisplayString(_ctx.version?_ctx.version:'-'), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_55, [
              _createElementVNode("div", _hoisted_56, [
                _hoisted_57,
                _createElementVNode("span", _hoisted_58, _toDisplayString(_ctx.submittedById), 1)
              ])
            ]),
            false
              ? (_openBlock(), _createElementBlock("div", _hoisted_59, [
                  _createElementVNode("div", _hoisted_60, [
                    _hoisted_61,
                    _createElementVNode("span", _hoisted_62, [
                      _hoisted_63,
                      _createVNode(_component_font_awesome_icon, { icon: "fa-solid fa-earth-asia" })
                    ])
                  ]),
                  _hoisted_64
                ]))
              : _createCommentVNode("", true),
            (_ctx.languages)
              ? (_openBlock(), _createElementBlock("div", _hoisted_65, [
                  _createElementVNode("div", _hoisted_66, [
                    _hoisted_67,
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.languages, (language, index) => {
                      return (_openBlock(), _createElementBlock("div", {
                        class: "text-gray-text text-sm",
                        key: index
                      }, [
                        _createElementVNode("span", _hoisted_68, _toDisplayString(language.name), 1),
                        _createTextVNode(" - " + _toDisplayString(language.audio?'Audio':'') + _toDisplayString(language.interface?', Interface':'') + _toDisplayString(language.subtitles?', Subtitles':'') + " ", 1),
                        _createVNode(_component_font_awesome_icon, {
                          icon: "fa-solid fa-earth-asia",
                          class: "inline-block ml-1"
                        })
                      ]))
                    }), 128))
                  ])
                ]))
              : _createCommentVNode("", true),
            (_ctx.tags)
              ? (_openBlock(), _createElementBlock("div", _hoisted_69, [
                  _createElementVNode("div", _hoisted_70, [
                    _createTextVNode(" Tag" + _toDisplayString(_ctx.tags.length > 1?'s':'') + ": ", 1),
                    (_ctx.tags.length > 0)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_71, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tags, (tag, index) => {
                            return (_openBlock(), _createElementBlock("div", {
                              class: "inline-block my-1 mr-1 rounded-lg px-3 py-0.5 bg-red-primary text-xs",
                              key: index
                            }, _toDisplayString(tag), 1))
                          }), 128))
                        ]))
                      : (_openBlock(), _createElementBlock("span", _hoisted_72, "-"))
                  ])
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_73, [
              _createElementVNode("div", _hoisted_74, [
                _hoisted_75,
                _createElementVNode("a", {
                  href: "#",
                  class: "text-red-primary",
                  onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.displayFeedbackModal = true), ["prevent"])),
                  id: "btnpopupFeedback"
                }, "Share your feedback for this game.")
              ])
            ])
          ])
        ])
      ])
    ]),
    false
      ? (_openBlock(), _createElementBlock("div", _hoisted_76, [
          _createElementVNode("div", _hoisted_77, [
            _createElementVNode("div", _hoisted_78, [
              _hoisted_79,
              _createElementVNode("div", _hoisted_80, [
                _createElementVNode("img", {
                  src: require(`@/assets/images/error.png`),
                  class: "w-25 mb-3"
                }, null, 8, _hoisted_81),
                _hoisted_82,
                _createElementVNode("div", _hoisted_87, [
                  _createElementVNode("button", _hoisted_88, [
                    _createVNode(_component_font_awesome_icon, {
                      icon: "fa-solid fa-lock",
                      class: "text-success"
                    }),
                    _hoisted_89
                  ])
                ]),
                _hoisted_90,
                _hoisted_91
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_GamesFeedbackModal, {
      gameId: _ctx.gameId,
      title: _ctx.title,
      displayFeedbackModal: _ctx.displayFeedbackModal,
      onCloseFeedbackModal: _cache[1] || (_cache[1] = ($event: any) => (_ctx.displayFeedbackModal = false))
    }, null, 8, ["gameId", "title", "displayFeedbackModal"])
  ]))
}